import globalthis from 'globalthis/polyfill';

export {
    globalthis,
};
